import { useEffect, useState } from "react";
import axios from "axios";
import "./DomainData.css";

const DomainData = () => {
  const [domainData, setDomainData] = useState({});
  const [openDomain, setOpenDomain] = useState(null);
  useEffect(() => {
    const fetchDomainData = async () => {
      try {
        const token = localStorage.getItem('token'); // Get token from localStorage

        if (!token) {
          throw new Error('No token found, please log in');
        }
        const response = await axios.get(
          "https://filesapi.infomanav.in/api/aws/get-domain-data",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log("Domain data:", response.data);
        setDomainData(response.data.result);
      } catch (err) {
        console.error("Error fetching domain data:", err);
      }
    };

    fetchDomainData();
  }, []);

  const toggleDomain = (domain) => {
    setOpenDomain((prev) => (prev === domain ? null : domain));
  };

  return (
    <div className="domain-wrapper">
      {/* <h2>Domain-wise Users</h2> */}
      {Object.keys(domainData).map((domain) => (
        <div key={domain} className="domain-section">
          <div className="domain-header" onClick={() => toggleDomain(domain)}>
            <div className="domain-left">
              <span
                className={`dropdown-icon ${
                  openDomain === domain ? "open" : ""
                }`}
              >
                ▸
              </span>
              <span>{domain}</span>
            </div>
            <span className="user-count">{domainData[domain].count} users</span>
          </div>

          {openDomain === domain && (
            <div className="user-list">
              {domainData[domain].users.map((user, index) => (
                <div key={index} className="user-card">
                  <div className="avatar">
                    {user.userAvatar ? (
                      <img src={user.userAvatar} alt="avatar" />
                    ) : (
                      <span className="initial">
                        {user.name?.charAt(0).toUpperCase() || "U"}
                      </span>
                    )}
                  </div>
                  <div className="user-details">
                    <p>
                      <strong>Name:</strong> {user.name || "-"}
                    </p>
                    <p>
                      <strong>Email:</strong> {user.email || "-"}
                    </p>
                    <p>
                      <strong>Permission:</strong> {user.permission || "-"}
                    </p>
                    <p>
                      <strong>Contact:</strong> {user.contact || "-"}
                    </p>
                    <p>
                      <strong>Bucket Type:</strong> {user.bucketType || "-"}
                    </p>
                    <p>
                      <strong>Folder Name:</strong> {user.folderName || "-"}
                    </p>
                    <p>
                      <strong>Last Login:</strong>{" "}
                      {formatLogin(user.lastLoginAt)}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

const formatLogin = (login) => {
  if (!login) return "-";
  const parts = login.split(" at ");
  if (parts.length === 2) {
    const [datePart, timePart] = parts;
    const time = timePart.split(":");
    return `${datePart.replace(/^.*?,\s/, "")} at ${time[0]}:${time[1]} ${
      time[2]?.split(" ")[1]
    }`;
  }
  return login;
};

export default DomainData;
